<template>
  <BuilderWrapper
    title="Story Formatting"
    helpful-tip="You can set font settings for each panel"
  >
    <PanelPicker
      :faq="faqEnabled"
      :splash-screen="splashScreenEnabled"
    />

    <PanelSettings :panel="panel" />
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import PanelPicker from '@/components/builder/StoryEditor/PanelPicker.vue'
import PanelSettings from '@/components/builder/StorySettings/PanelSettings.vue'

const components = {
  BuilderWrapper,
  PanelPicker,
  PanelSettings,
}

@Component({ components })
export default class StorySettings extends Vue {
  created () {
    this.$typedStore.public.display.setStoryBorder(true)
  }

  destroyed () {
    this.$typedStore.public.display.setStoryBorder(false)
  }

  get panel () {
    return this.$typedStore.public.display.storyBuilderPanel
  }

  get faqEnabled () {
    return this.$typedStore.primary.app.config?.faq.enabled ?? false
  }

  get splashScreenEnabled () {
    return this.$typedStore.primary.app.config?.splashScreen?.enabled ?? false
  }
}

</script>
